<div class="card-container">
  <mat-card class="card-message container">
    <div class="col">
      <div class="row mt-5 mb-5">
        <img
          class="perform-icon"
          src="../../../../assets/images/Havrion_Horiz.svg"
          alt="Havrion Logo"
          />
        </div>
        <div class="row mt-5 card-message-text">
          <div class="col text-center">
            <span><b> {{ message }} </b></span>
          </div>
        </div>
        <div class="row mb-3 card-message-text">
          <div class="col text-center">
            @if (showErrorMessage) {
              <span > <b>{{ errorMessage }} </b></span>
            }
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col">
            <div class="mt-3 mb-3 progress-bar-container">
              @if (showProgressBar) {
                <mat-progress-bar color="primary" class="progress-bar" mode="indeterminate"></mat-progress-bar>
              }
            </div>
          </div>
        </div>
        @if (showInput) {
          <div class="row justify-content-center card-input">
            <div class="col">
              <input
                type="text"
                [placeholder]="inputMessage"
                [(ngModel)]="inputValue"
                />
            </div>
            <div class="col-4 col-sm-3">
              <button
                mat-button
                (click)="onSubmitClick()"
                [disabled]="!inputValue || inputValue.trim().length === 0"
                 style="color: white"
              >
                  {{submitMessage}}
              </button>
            </div>
          </div>
        }
          <div class="row card-message-text">
            <div class="col mt-3 mb-5 text-center">
              @if (showFooterMessage) {
                <span class="footer-message"  > {{ footerMessage }} </span>
              }
            </div>
          </div>
        </div>
      </mat-card>
    </div>

